import flattenObject from "Utils/flattenObject";

export default function focusFirstError(errors: Record<string, any>, joinStyle: string): void {
  const errorEl = document.querySelector(
    Object.keys(flattenObject(errors, joinStyle))
      .map((fieldName) => `[name="${fieldName}"]`)
      .join(","),
  );

  if (errorEl && errorEl.focus) {
    errorEl.focus();
  }
}
